import useIsMobile from 'utils/hooks/useIsMobile'
import {useSelector} from 'react-redux'
import {Link, useLocation} from 'react-router-dom'
import './../../common/globalFontSize.css'

const DeviceHeader = (props: any) => {
  const location = useLocation()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  const isMobile = useIsMobile()

  const navLinks: {label: string; to: string; roles: string[]}[] = [
    {
      label: '단말기 등록 관리',
      to: '/device/register',
      roles: ['sys_admin', 'sys_user', 'inspector'],
    },
    {
      label: '단말기 검수/할당 관리',
      to: '/device/allocation',
      roles: ['sys_admin', 'sys_user', 'inspector'],
    },
    {
      label: '단말기 정보 관리',
      to: '/device/info',
      roles: ['sys_admin', 'sys_user', 'inspector', 'gov_user'],
    },
    {
      label: '단말기 수신영상 관리',
      to: '/device/images',
      roles: ['sys_admin', 'sys_user', 'inspector'],
    },
    {
      label: '단말기 HISTORY',
      to: '/device/history',
      roles: ['sys_admin'],
    },
  ]

  const visibleLinks = navLinks.filter((link) =>
    link.roles.includes(userInfo?.accountType)
  )

  return (
    <div className='bg-white rounded-lg shadow-sm mb-5'>
      <div className='px-6 pt-4 pb-0'>
        <div className='overflow-x-auto'>
          <ul
            className='nav nav-line-tabs nav-line-tabs-2x border-transparent font-bold flex-nowrap'
            style={{fontSize: isMobile ? '13px' : '18px'}}
          >
            {visibleLinks.map((link) => (
              <li key={link.to} className='nav-item'>
                <Link
                  className={
                    `nav-link text-active-primary whitespace-nowrap ` +
                    (isMobile ? 'mx-2 ' : 'mr-6 ') +
                    (location.pathname === link.to ? 'active' : '')
                  }
                  to={link.to}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default DeviceHeader
